import { RecalledValue } from "./RecalledValue";
import { RecallType } from "./RecallType";
import { QuestionnaireModel } from "../models/QuestionnaireModel";

export class SurveyRecalledValue extends RecalledValue {
    questionnaire: QuestionnaireModel;

    constructor(questionnaire: QuestionnaireModel) {
        super();
        this.questionnaire = questionnaire;
    }

    evaluateProperty(
        mode: RecallType,
        property: string,
        parameters: string[],
    ): string | RecalledValue {
        switch (property) {
            case "id":
                return this.questionnaire.surveyId.toString();
            case "name":
                return this.questionnaire.name;
        }
        if (this.questionnaire.surveyProperties) {
            const key = Object.keys(this.questionnaire.surveyProperties).find(
                (key) => key.toLowerCase() === property,
            );
            if (key !== undefined) {
                return this.questionnaire.surveyProperties[key];
            }
        }
        return this;
    }

    toCode(): string {
        return "";
    }

    toText(): string {
        return "";
    }
}
